import React, { useCallback } from 'react';
import { Trans } from 'react-i18next';
import StyledModal from '../StyledModal';
import { useDispatch } from 'react-redux';
import { revokeConsent } from '../../actions/linkedAccounts';

const RevokeWebsiteModal = ({ closeModal, isOpen, account, site }) => {
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      dispatch(
        revokeConsent({
          id: site.id,
        }),
      );

      closeModal();
    },
    [dispatch, site, closeModal],
  );

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={closeModal}
      title={
        'Revoke ' + account.name + "'s access to " + site.organization + '?'
      }
      primaryButton={{
        text: 'Revoke',
        action: handleSubmit,
      }}
    >
      <p>
        <Trans
          i18nKey="linkage.revokeWebsite.description_requestAccess"
          values={{
            email: account.email,
            name: account.name,
            organization: site.organization,
          }}
          components={{ bold: <b /> }}
        />
      </p>
    </StyledModal>
  );
};

export default RevokeWebsiteModal;
